import { Component, h, Host, Element } from '@stencil/core';


@Component({
    tag: 'lilu-sort-filter-wrapper',
    styleUrl: 'lilu-sort-filter-wrapper.scss',
    shadow: true
})
export class LiluSortFilterWrapper {

    @Element() el: HTMLElement;

    render() {
        return (
           <Host>
                <div class={`sort-filter-wrapper ${this.el.id === 'filter-button' ? 'hide-on-desktop' : ''}`}>
                    <slot name="label"></slot>
                    <slot></slot>
                </div>
           </Host>
        );
    }
}
